const DEFAULT_CURADORIAS = [
  {
    id: "variedades",
    title: "Variedades",
    subtitle: "O melhor do conhecimento geral",
    color: "#fccf1f",
    visible: true,
    categories: ["História", "Geografia", "Ciências", "Música", "Cinema", "Mundo Animal", "Curiosidades"],
  },
  {
    id: "cultura_pop",
    title: "Cultura Pop",
    subtitle: "Tendências e entretenimento",
    color: "#ec4899",
    visible: true,
    categories: ["Cinema e TV", "Conhecimentos Gerais", "Curiosidades", "Música"],
  },
  {
    id: "cultura_geek",
    title: "Cultura Geek",
    subtitle: "O universo nerd completo",
    color: "#a855f7",
    visible: true,
    categories: ["Séries", "Cinema", "Desenhos Animados", "Quadrinhos", "Games"],
  },
  {
    id: "karaoke",
    title: "Karaokê",
    subtitle: "Música, performance e diversão ao vivo",
    color: "#22d3ee",
    visible: true,
    categories: ["Pop", "Rock", "Nostalgia", "Hits atuais", "Temáticos", "Escolhas da noite"],
  },
];

const fallbackId = (value, index) =>
  String(value || `curadoria_${index + 1}`)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "") || `curadoria_${index + 1}`;

const normalizeComparableText = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

export const getDefaultCuradorias = () =>
  DEFAULT_CURADORIAS.map((item) => ({
    ...item,
    categories: [...item.categories],
  }));

export const normalizeCuradorias = (input) => {
  const list = Array.isArray(input) ? input : getDefaultCuradorias();
  if (list.length === 0) return getDefaultCuradorias();

  return list.map((item, index) => ({
    id: fallbackId(item?.id || item?.title, index),
    title: String(item?.title || `Curadoria ${index + 1}`).trim(),
    subtitle: String(item?.subtitle || "").trim(),
    color: String(item?.color || DEFAULT_CURADORIAS[index]?.color || "#fccf1f").trim(),
    visible: item?.visible !== false,
    categories: Array.isArray(item?.categories)
      ? item.categories.map((category) => String(category || "").trim()).filter(Boolean)
      : [],
  }));
};

export const getVisibleCuradorias = (curadorias) =>
  normalizeCuradorias(curadorias).filter((item) => item.visible !== false);

export const getCuradoriaByTitle = (curadorias, title) =>
  normalizeCuradorias(curadorias).find((item) => item.title === title) || null;

export const getCuradoriaTitles = (curadorias) =>
  normalizeCuradorias(curadorias).map((item) => item.title);

export const getVisibleCuradoriaTitles = (curadorias) =>
  getVisibleCuradorias(curadorias).map((item) => item.title);

export const resolveCuradoriaForEvent = (curadorias, event) => {
  const normalizedCuradorias = normalizeCuradorias(curadorias);
  const candidates = [
    event?.quiz_type,
    event?.quiz_category,
    event?.event_format,
    event?.event_type_label,
    event?.event_format_label,
    event?.title,
    event?.description,
    event?.special_title,
    event?.thematic_round_theme,
    event?.theme,
  ]
    .filter(Boolean)
    .map((value) => normalizeComparableText(value));

  const uniqueCandidates = [...new Set(candidates)].filter(Boolean);
  const karaokeCuradoria = normalizedCuradorias.find(
    (item) => normalizeComparableText(item.id) === "karaoke" || normalizeComparableText(item.title) === "karaoke"
  );

  if (
    karaokeCuradoria &&
    uniqueCandidates.some((value) => value.includes("karaoke") || value.includes("karaoke "))
  ) {
    return karaokeCuradoria;
  }

  return normalizedCuradorias.find((item) => {
    const title = normalizeComparableText(item.title);
    const id = normalizeComparableText(item.id);
    return uniqueCandidates.some((candidate) =>
      candidate === title ||
      candidate === id ||
      candidate.includes(title) ||
      candidate.includes(id) ||
      title.includes(candidate) ||
      id.includes(candidate)
    );
  }) || null;
};

export const hexToRgba = (hex, alpha = 1) => {
  const normalized = String(hex || "").replace("#", "").trim();
  const fullHex = normalized.length === 3
    ? normalized.split("").map((char) => `${char}${char}`).join("")
    : normalized;

  if (!/^[0-9a-fA-F]{6}$/.test(fullHex)) {
    return `rgba(252, 207, 31, ${alpha})`;
  }

  const int = Number.parseInt(fullHex, 16);
  const r = (int >> 16) & 255;
  const g = (int >> 8) & 255;
  const b = int & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const getCuradoriaVisuals = (curadoria) => {
  const color = curadoria?.color || "#fccf1f";
  return {
    color,
    borderColor: hexToRgba(color, 0.42),
    glowColor: hexToRgba(color, 0.12),
    panelBg: hexToRgba(color, 0.08),
    iconBg: hexToRgba(color, 0.16),
    badgeBg: hexToRgba(color, 0.14),
    badgeBorder: hexToRgba(color, 0.3),
  };
};
